import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

interface MagicLoadingProps {
  active: boolean;
  onMagic?: () => void;
  text?: string;
  buttonText?: string;
  delayMs?: number;
}

/**
 * Centered loading view that reveals a fallback "Magic Button" after a delay.
 */
export default function MagicLoading({
  active,
  onMagic,
  text = 'Loading... If this is taking a while, click the magic button below.',
  buttonText = 'Magic Button ✨',
  delayMs = 10000,
}: MagicLoadingProps) {
  const [showMagic, setShowMagic] = useState(false);

  useEffect(() => {
    if (!active) {
      setShowMagic(false);
      return;
    }
    const timerId = window.setTimeout(() => setShowMagic(true), delayMs);
    return () => window.clearTimeout(timerId);
  }, [active, delayMs]);

  if (!active) return null;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}
    >
      <CircularProgress />
      {showMagic && (
        <>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            {text}
          </Typography>
          {onMagic && (
            <Button
              variant="contained"
              color="primary"
              onClick={onMagic}
              sx={{
                mt: 2,
                px: 4,
                py: 1.5,
                fontWeight: 700,
                fontSize: '1.1rem',
                letterSpacing: 1,
                boxShadow: 3,
                background: 'linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)',
              }}
              startIcon={<span role="img" aria-label="magic wand">🪄</span>}
            >
              {buttonText}
            </Button>
          )}
        </>
      )}
    </Stack>
  );
}


